module.exports = __webpack_public_path__ + "static/media/img12.4bf192ba.svg";